import * as React from 'react';
import { SVGProps } from 'react';

export const House = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.69141 18.4299V28.7424H13.1914V21.2424C13.1914 20.7452 13.389 20.2682 13.7406 19.9166C14.0922 19.565 14.5691 19.3674 15.0664 19.3674H16.9414C17.4387 19.3674 17.9156 19.565 18.2672 19.9166C18.6189 20.2682 18.8164 20.7452 18.8164 21.2424V28.7424H26.3164V18.4299"
      stroke="#071114"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.94141 16.5549L14.6777 3.81864C14.8518 3.64441 15.0585 3.50619 15.2861 3.41188C15.5137 3.31758 15.7576 3.26904 16.0039 3.26904C16.2502 3.26904 16.4942 3.31758 16.7217 3.41188C16.9493 3.50619 17.156 3.64441 17.3302 3.81864L30.0664 16.5549"
      stroke="#071114"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default House;
